import baseURL from "../common/axios";
import { API_MSHospitalBaseUrl } from "../common/common";

class POPaymentTermsDetailsservices {
  insert(data_insert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "POPaymentTermsDetails/Create",
      data_insert
    );
  }
  deletedata(doc) {
    return baseURL.httpMSInventoryUrl.delete(
      "POPaymentTermsDetails/DeleteList?id=" + doc
    );
  }
  Get(Id) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("POPaymentTermsDetails/Get?Id=" + Id);
  }
  GetPaymentListByPoId(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "POPaymentTermsDetails/GetByPOId?POId=" + data
    );
  }

  UpdatePaymentInitiate(
    data,
    Status,
    EntityOperationId,
    DeptRoleId,
    EntityId,
    Reason
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "POPaymentTermsDetails/UpdatePaymentInitiate?Id=" +
        data +
        "&Status=" +
        Status +
        "&Reason=" +
        Reason +
        "&EntityOperationId=" +
        EntityOperationId +
        "&DeptRoleId=" +
        DeptRoleId +
        "&EntityId=" +
        EntityId
    );
  }

  UpdatePaymentApprovalStatus(Id, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "POPaymentTermsDetails/UpdatePaymentApprovalStatus?Id=" +
        Id +
        "&Status=" +
        Status
    );
  }
  UpdatePaymentFileUplaod(Id, FileName) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "POPaymentTermsDetails/UpdatePaymentFileUpload?Id=" +
        Id +
        "&FileName=" +
        FileName
    );
  }
  GetPaymentDashboard(StoreId, BranchId, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "POPaymentTermsDetails/GetPaymentDashboard?StoreId=" +
        StoreId +
        "&BranchId=" +
        BranchId +
        "&HospitalId=" +
        HospitalId
    );
  }
}
export default new POPaymentTermsDetailsservices();
